import React, { useCallback, useEffect } from 'react';
import Stack from "@mui/material/Stack";
import useJumboLayoutSidebar from "@jumbo/hooks/useJumboLayoutSidebar";
import AuthUserDropdown from "../../../../shared/widgets/AuthUserDropdown";
import NotificationsDropdown from "../../../../shared/NotificationsDropdown";
import MessagesDropdown from "../../../../shared/MessagesDropdown";
import SearchGlobal from "../../../../shared/SearchGlobal";
import {Button, Card, IconButton, Slide, TextField, ThemeProvider, Tooltip, Typography, useMediaQuery} from "@mui/material";
import Div from "@jumbo/shared/Div";
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import JumboIconButton from "@jumbo/components/JumboIconButton";
import MenuIcon from "@mui/icons-material/Menu";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import Logo from "../../../../shared/Logo";
import {SIDEBAR_STYLES, SIDEBAR_VARIANTS} from "@jumbo/utils/constants";
import useJumboHeaderTheme from "@jumbo/hooks/useJumboHeaderTheme";
import ShoppingCartCheckoutSharpIcon from '@mui/icons-material/ShoppingCartCheckoutSharp';
import JumboDdPopover from '@jumbo/components/JumboDdPopover';
import { Link, useNavigate } from 'react-router-dom';
import jwtAuthAxios from 'app/services/auth/jwtAuth';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import useJumboAuth from '@jumbo/hooks/useJumboAuth';

const Header = () => {
    const {sidebarOptions, setSidebarOptions} = useJumboLayoutSidebar();
    const [dropdownSearchVisibility, setDropdownSearchVisibility] = React.useState(false);
    const [CurrencyRate, setCurrencyRate] = React.useState(null);
    const {headerTheme} = useJumboHeaderTheme();
    const navigate = useNavigate()
    const jumboco = useJumboAuth();
    const swal = useSwalWrapper()
    const showDropdownSearch = useMediaQuery('(max-width:575px)');
    const frtchCurrencyRate = useCallback(()=>{
        jwtAuthAxios.get('master/currencyRate').then(async (res)=>{
            await jumboco.setAuthOptions({type:'set-curr',payload:{cd:'¥',Rate:res.data.data}})
            setCurrencyRate(res.data.data)
        })
    },[])
    // console.log(jumboco.menuObject.Gaurd.filter(s=> s.uri=='AdminBasket')[0]?.view ==1);
useEffect(()=>{
    // frtchCurrencyRate()
   
},[])
useEffect(()=>{
    // console.log(jumboco);
    jumboco?.curr?.Rate && setCurrencyRate(jumboco?.curr?.Rate)
},[jumboco])
    return (
        <React.Fragment>
            {
                (
                    sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER
                    || sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY
                    || (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT && !sidebarOptions.open)
                ) &&
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{
                            ml: sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ? -2 : 0,
                            mr: 3,
                        }}
                        onClick={() => setSidebarOptions({open: !sidebarOptions.open})}
                    >
                        {
                            sidebarOptions?.open ? <MenuOpenIcon/> : <MenuIcon/>
                        }
                    </IconButton>
            }
            {
                sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER &&
                <Logo sx={{mr: 3}} mode={headerTheme.type ?? "light"}/>
            }
            {/* {
                showDropdownSearch &&
                <Slide in={dropdownSearchVisibility}>
                    <Div
                        sx={{
                            zIndex: 5,
                            left: 0,
                            right: 0,
                            position: 'absolute',
                            height: '100%',
                        }}
                    >
                        <SearchGlobal
                            sx={{
                                maxWidth: 'none',
                                height: '100%',
                                display: 'flex',

                                '& .MuiInputBase-root': {
                                    flex: 1,
                                    borderRadius: 0,
                                    background: theme => theme.palette.background.default,
                                },
                                '& .MuiInputBase-input': {
                                    pr: 6,
                                }
                            }}
                        />
                        <IconButton
                            sx={{
                                position: 'absolute',
                                right: 15,
                                top: '50%',
                                color: 'inherit',
                                transform: 'translateY(-50%)',
                            }}
                            onClick={() => setDropdownSearchVisibility(false)}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </Div>
                </Slide>
            }
            {
                !showDropdownSearch &&
                <SearchGlobal
                    sx={{
                        maxWidth: {xs: 240, md: 320}
                    }}
                />
            } */}
            <Stack direction="row" alignItems="center" spacing={1.25} sx={{ml: "auto"}}>
                {/* {
                    showDropdownSearch &&
                    <JumboIconButton elevation={25} onClick={() => setDropdownSearchVisibility(true)}>
                        <SearchIcon fontSize={"small"}/>
                    </JumboIconButton>
                } */}
                {CurrencyRate &&  <JumboDdPopover triggerButton={ <Button id='CurrentCurecy_priview_btn' variant='outlined'>{'cn¥ ' + CurrencyRate}</Button>} >
                    {jumboco.authUser.FL_ROLE_ID ==1 && <Card sx={{ p: 2 }}>
                        <TextField fullWidth label={'Please Add New Rate'} sx={{ minWidth: '180px' }} id='input-latest-rate' type='number' size='small' />
                        <Button variant='contained' fullWidth sx={{ mt: 1 }} onClick={() => {
                            document.getElementById('input-latest-rate').value ? jwtAuthAxios.get(`master/currencyRate?type=i&rate=${document.getElementById('input-latest-rate').value}`).then((res) => {
                                swal.fire({
                                    icon: 'success',
                                    text: res.data.message,
                                }); frtchCurrencyRate()
                            }).catch(() =>
                                swal.fire({
                                    icon: 'error',
                                    text: 'something Went Wrong',
                                })
                            ) : swal.fire({
                                icon: 'error',
                                text: 'Please Fill Detail',
                            })
                        }}>Update</Button>
                    </Card>}
            </JumboDdPopover>}
                {/* {<JumboDdPopover triggerButton={ <Button id='FinYear_priview_btn' variant='outlined'>{'FinYear :- ' + jumboco?.authUser?.FINYEAR}</Button>} >
                <Card sx={{p:2}}>
               <form onSubmit={(e)=>{e.preventDefault();  jumboco.setAuthOptions({
                        type: "set-auth-data",
                        payload: {...jumboco,authUser:{...jumboco.authUser,FINYEAR:document.getElementById('input-FinYear_priview_btn').value}}
                    });}}>
                 <TextField fullWidth label={'Please Add FinYear'} sx={{minWidth:'180px'}} id='input-FinYear_priview_btn' type='number' inputProps={{
                    min:"2023",
                    max:new Date().getFullYear(),
                    defaultValue:jumboco?.authUser?.FINYEAR,
                    step:"1"
                }} size='small'/>
                <Button variant='contained' type='submit' fullWidth sx={{mt:1}} >Update</Button>
                </form>
            </Card>
            </JumboDdPopover>} */}
                   
                 <ThemeProvider theme={headerTheme}>
                        <JumboIconButton  elevation={25}>
                            <Tooltip title={"My Basket"}><Link to={jumboco?.menuObject?.Gaurd?.filter(s=> s.uri=='AdminBasket')[0]?.view ==1?'/mybasket':'/basket'}><svg xmlns="http://www.w3.org/2000/svg" width="50" height="48" viewBox="0 0 24 23" fill="none" style={{width:"33px",height:"61px"}}>
<g clipPath="url(#clip0_163_2928)">
<g clipPath="url(#clip1_163_2928)">
<path d="M20.9945 12.3517C20.9171 12.2255 20.7458 12.181 20.6072 12.2478L19.0699 13.0196L18.4665 13.3239L12.0566 16.5302C11.6284 16.7454 11.0902 16.6007 10.8578 16.2148C10.7436 16.0255 10.7191 15.8103 10.7844 15.6025C10.8496 15.3946 11.0005 15.2239 11.2084 15.1237L19.0781 11.1864L19.7631 10.845C19.9018 10.7745 19.9507 10.6187 19.8773 10.4925C19.7998 10.3663 19.6286 10.3218 19.4899 10.3886L19.1433 10.563L18.1403 6.29914C18.0913 6.06906 17.9282 5.87609 17.6917 5.7759C17.4552 5.6757 17.1902 5.68312 16.9618 5.79816L7.04529 10.7523L5.663 9.46086C5.5733 9.37551 5.43466 9.35695 5.32049 9.41262L3.63239 10.2587C3.49375 10.3292 3.44482 10.4851 3.51822 10.6112C3.59569 10.7374 3.76695 10.782 3.90558 10.7152L5.40612 9.96555L6.78432 11.257L10.6335 14.8603C10.446 15.0198 10.3073 15.2239 10.2339 15.4577C10.1238 15.7991 10.1687 16.1554 10.3562 16.4634C10.6213 16.9013 11.1187 17.1499 11.6325 17.1499C11.869 17.1499 12.1096 17.098 12.3298 16.9866L12.8028 16.7491C12.8272 16.8159 12.8598 16.8827 12.8965 16.9458C13.0719 17.2353 13.3614 17.4468 13.708 17.5359C13.8344 17.5693 13.9608 17.5841 14.0872 17.5841C14.3115 17.5841 14.5357 17.5321 14.7396 17.432C15.0576 17.2724 15.2901 17.0126 15.3879 16.6935C15.4899 16.378 15.4491 16.0441 15.2737 15.7546C15.2371 15.6915 15.1922 15.6321 15.1433 15.5765L17.3492 14.4743C17.3737 14.5411 17.4063 14.6079 17.443 14.671C17.6183 14.9605 17.9078 15.172 18.2544 15.2611C18.3808 15.2945 18.5072 15.3093 18.6336 15.3093C18.8579 15.3093 19.0822 15.2573 19.286 15.1571C19.6041 14.9976 19.8365 14.7378 19.9344 14.4187C20.0363 14.1032 19.9955 13.7693 19.8202 13.4798C19.7835 13.4167 19.7386 13.3573 19.6897 13.3017L20.8804 12.7079C21.0231 12.6337 21.072 12.4778 20.9945 12.3517ZM16.7335 7.2714C16.8885 7.24172 17.0393 7.33078 17.0719 7.4718L17.7366 10.2884C17.7692 10.4294 17.6713 10.5667 17.5164 10.5964C17.496 10.6001 17.4756 10.6038 17.4552 10.6038C17.3247 10.6038 17.2065 10.5222 17.178 10.3997L16.5133 7.58312C16.4807 7.4384 16.5786 7.30109 16.7335 7.2714Z" fill="#3B4652"></path>
<path d="M4.69254 12.0325C4.69254 11.8878 4.56613 11.7728 4.40711 11.7728H1.41012C1.2511 11.7728 1.12469 11.8878 1.12469 12.0325C1.12469 12.1773 1.2511 12.2923 1.41012 12.2923H4.40711C4.56613 12.2923 4.69254 12.1773 4.69254 12.0325Z" fill="#2B79C2"></path>
<path d="M4.37451 15.6396C4.37451 15.7843 4.50092 15.8994 4.65994 15.8994H8.35826C8.51729 15.8994 8.64369 15.7843 8.64369 15.6396C8.64369 15.4949 8.51729 15.3798 8.35826 15.3798H4.65994C4.50092 15.3798 4.37451 15.4949 4.37451 15.6396Z" fill="#2B79C2"></path>
<path d="M2.25415 14.1478C2.25415 14.2925 2.38055 14.4075 2.53958 14.4075H7.54271C7.70174 14.4075 7.82814 14.2925 7.82814 14.1478C7.82814 14.003 7.70174 13.888 7.54271 13.888H2.53958C2.38055 13.888 2.25415 14.003 2.25415 14.1478Z" fill="#2B79C2"></path>
<path d="M6.99229 13.2534C7.15132 13.2534 7.27772 13.1384 7.27772 12.9937C7.27772 12.8489 7.15132 12.7339 6.99229 12.7339H5.65078C5.49176 12.7339 5.36536 12.8489 5.36536 12.9937C5.36536 13.1384 5.49176 13.2534 5.65078 13.2534H6.99229Z" fill="#2B79C2"></path>
<path d="M9.27977 14.3148H8.65591C8.49689 14.3148 8.37048 14.4298 8.37048 14.5745C8.37048 14.7193 8.49689 14.8343 8.65591 14.8343H9.27977C9.4388 14.8343 9.5652 14.7193 9.5652 14.5745C9.5652 14.4298 9.4388 14.3148 9.27977 14.3148Z" fill="#2B79C2"></path>
<path d="M9.27979 16.5413H6.91482C6.7558 16.5413 6.62939 16.6564 6.62939 16.8011C6.62939 16.9458 6.7558 17.0609 6.91482 17.0609H9.27979C9.43882 17.0609 9.56522 16.9458 9.56522 16.8011C9.56522 16.6564 9.43882 16.5413 9.27979 16.5413Z" fill="#2B79C2"></path>
<path d="M5.38164 16.5413H3.59976C3.44073 16.5413 3.31433 16.6564 3.31433 16.8011C3.31433 16.9458 3.44073 17.0609 3.59976 17.0609H5.38164C5.54066 17.0609 5.66707 16.9458 5.66707 16.8011C5.66707 16.6564 5.53659 16.5413 5.38164 16.5413Z" fill="#2B79C2"></path>
<path d="M2.72717 15.261H1.78933C1.63031 15.261 1.50391 15.3761 1.50391 15.5208C1.50391 15.6655 1.63031 15.7806 1.78933 15.7806H2.72717C2.88619 15.7806 3.01259 15.6655 3.01259 15.5208C3.01259 15.3761 2.88619 15.261 2.72717 15.261Z" fill="#2B79C2"></path>
<path d="M3.59978 13.2534C3.7588 13.2534 3.88521 13.1384 3.88521 12.9937C3.88521 12.8489 3.7588 12.7339 3.59978 12.7339H3.12271C2.96368 12.7339 2.83728 12.8489 2.83728 12.9937C2.83728 13.1384 2.96368 13.2534 3.12271 13.2534H3.59978Z" fill="#2B79C2"></path>
</g>
</g>
<defs>
<clipPath id="clip0_163_2928">
<rect width="22.8571" height="22.8571" fill="white" transform="translate(0.806885 0.142883)"></rect>
</clipPath>
<clipPath id="clip1_163_2928">
<rect width="20.877" height="19" fill="white" transform="translate(0.639465 2.14288)"></rect>
</clipPath>
</defs>
</svg></Link></Tooltip>
                        </JumboIconButton>
                    </ThemeProvider>
                {/* <MessagesDropdown/>
                <NotificationsDropdown/> */}
                <AuthUserDropdown/>
            </Stack>
        </React.Fragment>
    );
};

export default Header;
